import Styles from '../LinkManager.module.scss'
import { Button } from 'blaze-ui/Button'
import { Edit1, ArrowRefresh } from 'blaze-ui/icons/20'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'

interface ActionButtonsProps {
  onPasteOwn: () => void
  onGenerateMore: () => void
}

export const ActionButtons = ({ onPasteOwn, onGenerateMore }: ActionButtonsProps) => (
  <MobileWizard.Section>
    <div className={Styles.actionButtons}>
      <Button variant="tertiary" size="md" frontIcon={Edit1} onPress={onPasteOwn} fullWidth>
        Paste Your Own
      </Button>

      <Button
        variant="ghost"
        size="md"
        frontIcon={ArrowRefresh}
        onPress={onGenerateMore}
        fullWidth
        className={Styles.generateButton}
      >
        Generate 5 More
      </Button>
    </div>
  </MobileWizard.Section>
)
